import Typography from "@mui/material/Typography";

const CellTypography = ({ children, sx = {} }) => {
  return (
    <Typography variant="body2" sx={sx}>
      {children}
    </Typography>
  );
};

export default CellTypography;
